<script>
  import { onMount } from "svelte";
  import Loading from "../../../../components/pages/Loading.svelte";
  import DialogTitle from "../../../../components/dialog/DialogTitle.svelte";
  import DialogSplitter from "../../../../components/dialog/DialogSplitter.svelte";
  import DialogContent from "../../../../components/dialog/DialogContent.svelte";
  import DialogBottomControls from "../../../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../../../components/dialog/DialogBottomControlButton.svelte";
  import DisplaySerialInfo from "../DisplaySerialInfo.svelte";
  import PrimaryButton from "../../../../components/button/generic/PrimaryButton.svelte";
  import { getNotificationsContext } from "svelte-notifications"
  import { useInvalidateLicenseData } from "../../../../hooks/license/useLicenseData.js";
  import { translate } from "../../../../i18n/i18next.js";
  import InitEProtectorLicenseAuthenticationDialogContent
    from "../InitEProtectorLicenseAuthenticationDialog/InitEProtectorLicenseAuthenticationDialogContent.svelte";

  export let onClickBack
  export let onClickClose

  const {addNotification} = getNotificationsContext()
  const {invalidateLicenseData} = useInvalidateLicenseData()

  let isRequesting = false
  async function onClickUseLicense() {
    isRequesting = true
    const response = await fetch("/api/license/e-protector/use", {
      method: "POST",
    })
    if (response.ok) {
      addNotification({
        text: translate("frontend:components.changeLicenseAuthenticationMethodDialog.configureEProtector.messages.enabled"),
        position: "top-right",
        removeAfter: 4000,
        type: "success",
      });
      onClickClose()
      await invalidateLicenseData()
    } else {
      const responseData = await response.json()
      addNotification({
        text: translate("frontend:components.changeLicenseAuthenticationMethodDialog.configureEProtector.messages.enablementFailed", null, {error: responseData?.type}),
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      });
    }
    isRequesting = false
  }

  let status = "loading"
  let loadedData = null
  onMount(async () => {
    const response = await fetch("/api/license/e-protector")
    loadedData = await response.json().catch(() => null)
    if (response.ok) status = "alreadyInstalled"
    else status = "notAvailable"
  })
</script>


{#if status === "alreadyInstalled"}
  <DialogTitle title={translate("frontend:components.changeLicenseAuthenticationMethodDialog.configureEProtector.title")}/>
  <DialogSplitter/>
  <DialogContent>
    <div>
      {translate("frontend:components.changeLicenseAuthenticationMethodDialog.configureEProtector.messages.alreadyInstalled")}
    </div>
    <div class="license-container">
      <DisplaySerialInfo license={loadedData} />
      <div style="display: flex; justify-content: end;">
        <PrimaryButton
          onClick={onClickUseLicense}
          disabled={isRequesting || !loadedData.validityPeriod.isValid.ok}
        >
          {translate("frontend:components.changeLicenseAuthenticationMethodDialog.configureEProtector.useLicense.label")}
        </PrimaryButton>
      </div>
    </div>
  </DialogContent>
  <DialogSplitter/>
  <DialogBottomControls>
    <DialogBottomControlButton type="secondary" onClick={onClickClose}>
      {translate("generic.close")}
    </DialogBottomControlButton>
  </DialogBottomControls>
{:else if status === "notAvailable"}
  <InitEProtectorLicenseAuthenticationDialogContent onClose={onClickClose} />
{:else}
  <Loading height="200px"/>
{/if}

<style>
  .license-container {
    padding: 1rem 0;
    border-top: 1px solid darkgrey;
    border-bottom: 1px solid darkgrey;
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }
</style>
